import * as L from 'leaflet';
import MapConstants from 'constants/map/map';
import {
    ColorBlueDark3,
    ColorLimeDark2,
    ColorYellowDark1,
    ColorOrangeLight3,
    ColorRedDark1
} from 'ui-connect/styles/default-theme';

export const mapProviderInfo = {
    google: {
        value: 'google',
        key: 'AIzaSyBuqMiuCNohSYg09UnOzu9Poy05jND5m3k',
        types: {
            default: 'ROADMAP',
            satellite: 'SATELLITE',
            terrain: 'TERRAIN',
            hybrid: 'HYBRID'
        },
        options: {
            minZoom: 3,
            maxZoom: 21,
            noWrap: true
        }
    },
    bing: {
        value: 'bing'
    },
    here: {
        value: 'here',
        attribution: '&copy; <a href="https://legal.here.com/terms/serviceterms" />HERE maps.</a>',
        mapViewType: {
            normal: 'explore.day',
            satellite: 'satellite.day',
            terrain: 'terrain',
            hybrid: 'explore.satellite.day'
        },
        options: {
            minZoom: 3,
            maxZoom: 18
        },
        appId: MapConstants.HereAppId,
        apiKey: MapConstants.HereApiKey
    },
    osm: {
        value: 'osm',
        options: {
            minZoom: 3,
            maxZoom: 17,
            maxNativeZoom: 17,
            attribution:
                '&copy; <a href="https://openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMaps</a> contributors &copy; Garmin Ltd. or its Affiliates '
        }
    },
    baidu: {
        value: 'baidu',
        baiduKey: MapConstants.baiduKey,
        type: {
            default: 'ROAD.Map',
            satellite: 'SATELLITE.Map',
            terrain: 'ROAD.Map'
        },
        options: {
            minZoom: 3,
            maxZoom: 18,
            subdomains: '0123',
            crs: L.CRS.BEPSG3857,
            attribution: `© ${new Date().getFullYear()} Baidu - GS(2021)6026号 - 甲测资字11111342 - 京ICP证030173号 - Data © 百度智图`
        }
    }
};

export const MAP_SETTINGS_KEYS = {
    mapProvider: 'map_provider_type',
    userHasSeenMetricBasedTrackLog: 'User_Has_Seen_Metric_Based_Track_Log'
};

export const activityHeatMapPalette = {
    0.2: ColorBlueDark3,
    0.4: ColorLimeDark2,
    0.6: ColorYellowDark1,
    0.8: ColorOrangeLight3,
    1.0: ColorRedDark1
};

const constants = {
    mapProviderInfo,
    activityHeatMapPalette
};

export default constants;
